import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import { Typography } from "antd";
import "leaflet/dist/leaflet.css";

const { Text } = Typography;

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const COLOMBIA_CENTER = [4.5709, -74.2973];

const isValidPos = (pos) => {
  if (!Array.isArray(pos) || pos.length < 2) return false;
  const lat = parseFloat(pos[0]);
  const lng = parseFloat(pos[1]);
  return !Number.isNaN(lat) && !Number.isNaN(lng) && isFinite(lat) && isFinite(lng);
};

function ClickHandler({ onSelect }) {
  useMapEvents({
    click(e) {
      onSelect([e.latlng.lat, e.latlng.lng]);
    },
  });
  return null;
}

export default function LocationPicker({ position, onSelect, t }) {
  const valid = isValidPos(position);
  const center = valid ? position : COLOMBIA_CENTER;
  const zoom = valid ? 15 : 6;
  const mapKey = valid ? `${position[0]}-${position[1]}` : "default";

  return (
    <div>
      <div
        style={{
          height: 320,
          borderRadius: 8,
          overflow: "hidden",
          border: "1px solid #d9d9d9",
          cursor: "crosshair",
        }}
      >
        <MapContainer
          key={mapKey}
          center={center}
          zoom={zoom}
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          />
          <ClickHandler onSelect={onSelect} />
          {valid && <Marker position={position} />}
        </MapContainer>
      </div>

      <div style={{ marginTop: 8, display: "flex", gap: 24 }}>
        <Text type="secondary">
          {t("deviceNew.lat")}:{" "}
          <Text strong>{valid ? parseFloat(position[0]).toFixed(6) : "—"}</Text>
        </Text>
        <Text type="secondary">
          {t("deviceNew.long")}:{" "}
          <Text strong>{valid ? parseFloat(position[1]).toFixed(6) : "—"}</Text>
        </Text>
      </div>
    </div>
  );
}
